// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__1vNs_","contained":"OpenButton_contained__2k8nA","disabled":"OpenButton_disabled__2fCw_","error":"OpenButton_error__3TRTL"};